import { Box } from '@chakra-ui/react';
import CreateBusSegment from '../../../../../../../../components/SitePublicTransport/CreateBusSegment';

export default function PagePublicTransportSegment() {
  return (
    <Box flex="1 1 0" overflow="hidden">
      <CreateBusSegment />
    </Box>
  );
}
